import { API_URL } from './RestAPI'
import { HttpClient } from './httpClient'
import apiHeaders from './apiHeaders'

const toggleMicrosoftSso = (micSso) => {
  return HttpClient.put(
    `${API_URL}/ssoMicrosoft/${micSso.id}/update`,
    micSso,
    apiHeaders()
  )
}

const getSecureUrl = () => {
  return HttpClient.get(`${process.env.REACT_APP_STORE_URL}/auth/sso/microsoft/secure-connect-url`, apiHeaders())
}

const disconnectMicrosoft = (micSsoId) => {
  return HttpClient.delete(
    `${API_URL}/ssoMicrosoft/${micSsoId}/disconnect`, apiHeaders()
  )
}

const SsoMicrosoftApi = { toggleMicrosoftSso, getSecureUrl, disconnectMicrosoft }

export { SsoMicrosoftApi }
